export default function RecivedIcon() {
  return (
    <svg
      className='mr-2'
      width='40'
      height='40'
      viewBox='0 0 40 40'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <circle cx='20' cy='20' r='20' fill='#BBEDC0' />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M15.75 15.5C15.75 13.1528 17.6528 11.25 20 11.25C22.3472 11.25 24.25 13.1528 24.25 15.5C24.25 17.8472 22.3472 19.75 20 19.75C17.6528 19.75 15.75 17.8472 15.75 15.5ZM20 12.75C18.4812 12.75 17.25 13.9812 17.25 15.5C17.25 17.0188 18.4812 18.25 20 18.25C21.5188 18.25 22.75 17.0188 22.75 15.5C22.75 13.9812 21.5188 12.75 20 12.75Z'
        fill='black'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M16 22.75C14.7574 22.75 13.75 23.7574 13.75 25V26.1883C13.75 26.2064 13.7631 26.2218 13.781 26.2247C17.8997 26.8972 22.1003 26.8972 26.219 26.2247C26.2369 26.2218 26.25 26.2064 26.25 26.1883V25C26.25 23.7574 25.2426 22.75 24 22.75H23.6591C23.6328 22.75 23.6066 22.7542 23.5815 22.7623L22.716 23.045C20.9512 23.6212 19.0488 23.6212 17.284 23.045L16.4185 22.7623C16.3934 22.7542 16.3672 22.75 16.3409 22.75H16ZM12.25 25C12.25 22.9289 13.9289 21.25 16 21.25H16.3409C16.5254 21.25 16.7087 21.2792 16.8841 21.3364L17.7496 21.6191C19.2119 22.0965 20.7881 22.0965 22.2504 21.6191L23.1159 21.3364C23.2913 21.2792 23.4746 21.25 23.6591 21.25H24C26.0711 21.25 27.75 22.9289 27.75 25V26.1883C27.75 26.9415 27.2041 27.5837 26.4607 27.7051C22.1819 28.4037 17.8181 28.4037 13.5393 27.7051C12.7959 27.5837 12.25 26.9415 12.25 26.1883V25Z'
        fill='black'
      />
    </svg>
  );
}
export function AboutIcon() {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      className='h-6 w-6 text-gray-500'
      fill='none'
      viewBox='0 0 24 24'
      stroke='currentColor'
      strokeWidth='2'
    >
      <path
        strokeLinecap='round'
        strokeLinejoin='round'
        d='M10 6H5a2 2 0 00-2 2v9a2 2 0 002 2h14a2 2 0 002-2V8a2 2 0 00-2-2h-5m-4 0V5a2 2 0 114 0v1m-4 0a2 2 0 104 0m-5 8a2 2 0 100-4 2 2 0 000 4zm0 0c1.306 0 2.417.835 2.83 2M9 14a3.001 3.001 0 00-2.83 2M15 11h3m-3 4h2'
      />
    </svg>
  );
}
export function XCircleIcon() {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      className='h-8 w-8 text-red-500'
      fill='none'
      viewBox='0 0 24 24'
      stroke='currentColor'
      strokeWidth='2'
    >
      <path
        strokeLinecap='round'
        strokeLinejoin='round'
        d='M10 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2m7-2a9 9 0 11-18 0 9 9 0 0118 0z'
      />
    </svg>
  );
}
export function SupportIcon() {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      className='h-6 w-6 text-gray-500'
      fill='none'
      viewBox='0 0 24 24'
      stroke='currentColor'
      strokeWidth='2'
    >
      <path
        strokeLinecap='round'
        strokeLinejoin='round'
        d='M18.364 5.636l-3.536 3.536m0 5.656l3.536 3.536M9.172 9.172L5.636 5.636m3.536 9.192l-3.536 3.536M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-5 0a4 4 0 11-8 0 4 4 0 018 0z'
      />
    </svg>
  );
}
export function SettingIcon() {
  return (
    <svg
      fill='#84A096'
      className='m-auto'
      xmlns='http://www.w3.org/2000/svg'
      viewBox='0 0 24 24'
      width='24px'
      height='24px'
    >
      <path d='M 10.490234 2 C 10.011234 2 9.6017656 2.3385938 9.5097656 2.8085938 L 9.1757812 4.5234375 C 8.3550224 4.8338012 7.5961042 5.2674041 6.9296875 5.8144531 L 5.2851562 5.2480469 C 4.8321563 5.0920469 4.33375 5.2793594 4.09375 5.6933594 L 2.5859375 8.3066406 C 2.3469375 8.7216406 2.4339219 9.2485 2.7949219 9.5625 L 4.1132812 10.708984 C 4.0447181 11.130337 4 11.559284 4 12 C 4 12.440716 4.0447181 12.869663 4.1132812 13.291016 L 2.7949219 14.4375 C 2.4339219 14.7515 2.3469375 15.278359 2.5859375 15.693359 L 4.09375 18.306641 C 4.33275 18.721641 4.8321562 18.908906 5.2851562 18.753906 L 6.9296875 18.1875 C 7.5958842 18.734206 8.3553934 19.166339 9.1757812 19.476562 L 9.5097656 21.191406 C 9.6017656 21.661406 10.011234 22 10.490234 22 L 13.509766 22 C 13.988766 22 14.398234 21.661406 14.490234 21.191406 L 14.824219 19.476562 C 15.644978 19.166199 16.403896 18.732596 17.070312 18.185547 L 18.714844 18.751953 C 19.167844 18.907953 19.66625 18.721641 19.90625 18.306641 L 21.414062 15.691406 C 21.653063 15.276406 21.566078 14.7515 21.205078 14.4375 L 19.886719 13.291016 C 19.955282 12.869663 20 12.440716 20 12 C 20 11.559284 19.955282 11.130337 19.886719 10.708984 L 21.205078 9.5625 C 21.566078 9.2485 21.653063 8.7216406 21.414062 8.3066406 L 19.90625 5.6933594 C 19.66725 5.2783594 19.167844 5.0910937 18.714844 5.2460938 L 17.070312 5.8125 C 16.404116 5.2657937 15.644607 4.8336609 14.824219 4.5234375 L 14.490234 2.8085938 C 14.398234 2.3385937 13.988766 2 13.509766 2 L 10.490234 2 z M 12 8 C 14.209 8 16 9.791 16 12 C 16 14.209 14.209 16 12 16 C 9.791 16 8 14.209 8 12 C 8 9.791 9.791 8 12 8 z' />
    </svg>
  );
}
export function EditIcon() {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      className='h-6 w-6 text-green-500'
      fill='none'
      viewBox='0 0 24 24'
      stroke='currentColor'
      strokeWidth='2'
    >
      <path
        strokeLinecap='round'
        strokeLinejoin='round'
        d='M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z'
      />
    </svg>
  );
}
export function PersonIcon() {
  return (
    <svg
      className='h-5'
      xmlns='http://www.w3.org/2000/svg'
      fill='none'
      viewBox='0 0 24 24'
      stroke='currentColor'
    >
      <path
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth='2'
        d='M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z'
      />
    </svg>
  );
}
export function ViewIcon() {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      className='h-6 w-6 text-gray-500'
      fill='none'
      viewBox='0 0 24 24'
      stroke='currentColor'
      strokeWidth='2'
    >
      <path
        strokeLinecap='round'
        strokeLinejoin='round'
        d='M15 12a3 3 0 11-6 0 3 3 0 016 0z'
      />
      <path
        strokeLinecap='round'
        strokeLinejoin='round'
        d='M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z'
      />
    </svg>
  );
}
export function EuroIcon() {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      className='h-6 w-6 text-gray-500'
      fill='none'
      viewBox='0 0 24 24'
      stroke='currentColor'
      strokeWidth='2'
    >
      <path
        strokeLinecap='round'
        strokeLinejoin='round'
        d='M14.121 15.536c-1.171 1.952-3.07 1.952-4.242 0-1.172-1.953-1.172-5.119 0-7.072 1.171-1.952 3.07-1.952 4.242 0M8 10.5h4m-4 3h4m9-1.5a9 9 0 11-18 0 9 9 0 0118 0z'
      />
    </svg>
  );
}
export function QuestionIcon() {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      className='h-6 w-6 text-gray-500'
      fill='none'
      viewBox='0 0 24 24'
      stroke='currentColor'
      strokeWidth='2'
    >
      <path
        strokeLinecap='round'
        strokeLinejoin='round'
        d='M8.228 9c.549-1.165 2.03-2 3.772-2 2.21 0 4 1.343 4 3 0 1.4-1.278 2.575-3.006 2.907-.542.104-.994.54-.994 1.093m0 3h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z'
      />
    </svg>
  );
}

export function CheckCircleIcon() {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      className='h-8 w-8 text-green-500'
      viewBox='0 0 20 20'
      fill='currentColor'
    >
      <path
        fill-rule='evenodd'
        d='M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z'
        clip-rule='evenodd'
      />
    </svg>
  );
}
export function CanceledIcon() {
  return (
    <svg
      className='mr-2'
      width='40'
      height='40'
      viewBox='0 0 40 40'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <circle cx='20' cy='20' r='20' fill='#FFE6D6' />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M15.75 14.5C15.75 12.1528 17.6528 10.25 20 10.25C22.3472 10.25 24.25 12.1528 24.25 14.5C24.25 16.8472 22.3472 18.75 20 18.75C17.6528 18.75 15.75 16.8472 15.75 14.5ZM20 11.75C18.4812 11.75 17.25 12.9812 17.25 14.5C17.25 16.0188 18.4812 17.25 20 17.25C21.5188 17.25 22.75 16.0188 22.75 14.5C22.75 12.9812 21.5188 11.75 20 11.75Z'
        fill='black'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M16 21.75C14.7574 21.75 13.75 22.7574 13.75 24V25.1883C13.75 25.2064 13.7631 25.2218 13.781 25.2247C17.8997 25.8972 22.1003 25.8972 26.219 25.2247C26.2369 25.2218 26.25 25.2064 26.25 25.1883V24C26.25 22.7574 25.2426 21.75 24 21.75H23.6591C23.6328 21.75 23.6066 21.7542 23.5815 21.7623L22.716 22.045C20.9512 22.6212 19.0488 22.6212 17.284 22.045L16.4185 21.7623C16.3934 21.7542 16.3672 21.75 16.3409 21.75H16ZM12.25 24C12.25 21.9289 13.9289 20.25 16 20.25H16.3409C16.5254 20.25 16.7087 20.2792 16.8841 20.3364L17.7496 20.6191C19.2119 21.0965 20.7881 21.0965 22.2504 20.6191L23.1159 20.3364C23.2913 20.2792 23.4746 20.25 23.6591 20.25H24C26.0711 20.25 27.75 21.9289 27.75 24V25.1883C27.75 25.9415 27.2041 26.5837 26.4607 26.7051C22.1819 27.4037 17.8181 27.4037 13.5393 26.7051C12.7959 26.5837 12.25 25.9415 12.25 25.1883V24Z'
        fill='black'
      />
    </svg>
  );
}
export function PendingIcon() {
  return (
    <svg
      className='mr-2'
      width='40'
      height='40'
      viewBox='0 0 40 40'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <circle cx='20' cy='20' r='20' fill='#B1D4F1' />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M15.75 14.5C15.75 12.1528 17.6528 10.25 20 10.25C22.3472 10.25 24.25 12.1528 24.25 14.5C24.25 16.8472 22.3472 18.75 20 18.75C17.6528 18.75 15.75 16.8472 15.75 14.5ZM20 11.75C18.4812 11.75 17.25 12.9812 17.25 14.5C17.25 16.0188 18.4812 17.25 20 17.25C21.5188 17.25 22.75 16.0188 22.75 14.5C22.75 12.9812 21.5188 11.75 20 11.75Z'
        fill='black'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M16 21.75C14.7574 21.75 13.75 22.7574 13.75 24V25.1883C13.75 25.2064 13.7631 25.2218 13.781 25.2247C17.8997 25.8972 22.1003 25.8972 26.219 25.2247C26.2369 25.2218 26.25 25.2064 26.25 25.1883V24C26.25 22.7574 25.2426 21.75 24 21.75H23.6591C23.6328 21.75 23.6066 21.7542 23.5815 21.7623L22.716 22.045C20.9512 22.6212 19.0488 22.6212 17.284 22.045L16.4185 21.7623C16.3934 21.7542 16.3672 21.75 16.3409 21.75H16ZM12.25 24C12.25 21.9289 13.9289 20.25 16 20.25H16.3409C16.5254 20.25 16.7087 20.2792 16.8841 20.3364L17.7496 20.6191C19.2119 21.0965 20.7881 21.0965 22.2504 20.6191L23.1159 20.3364C23.2913 20.2792 23.4746 20.25 23.6591 20.25H24C26.0711 20.25 27.75 21.9289 27.75 24V25.1883C27.75 25.9415 27.2041 26.5837 26.4607 26.7051C22.1819 27.4037 17.8181 27.4037 13.5393 26.7051C12.7959 26.5837 12.25 25.9415 12.25 25.1883V24Z'
        fill='black'
      />
    </svg>
  );
}
export function DashboardIcon() {
  return (
    <svg
      aria-hidden='true'
      className='flex-shrink-0 w-6 h-6 text-gray-500 transition duration-75 dark:text-gray-400 group-hover:text-gray-900 dark:group-hover:text-white'
      fill='currentColor'
      viewBox='0 0 20 20'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path d='M5 3a2 2 0 00-2 2v2a2 2 0 002 2h2a2 2 0 002-2V5a2 2 0 00-2-2H5zM5 11a2 2 0 00-2 2v2a2 2 0 002 2h2a2 2 0 002-2v-2a2 2 0 00-2-2H5zM11 5a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2V5zM11 13a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2v-2z'></path>
    </svg>
  );
}
export function TransactionIcon() {
  return (
    <svg
      aria-hidden='true'
      className='flex-shrink-0 w-6 h-6 text-gray-500 transition duration-75 dark:text-gray-400 dark:group-hover:text-white'
      fill='currentColor'
      stroke='currentColor'
      viewBox='0 0 22 22'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth='2'
        d='M8 7h12m0 0l-4-4m4 4l-4 4m0 6H4m0 0l4 4m-4-4l4-4'
      ></path>
    </svg>
  );
}
export function RecipientIcon() {
  return (
    <svg
      aria-hidden='true'
      className='flex-shrink-0 w-6 h-6 text-gray-500 transition duration-75'
      fill='currentColor'
      viewBox='0 0 20 20'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        fillRule='evenodd'
        d='M10 9a3 3 0 100-6 3 3 0 000 6zm-7 9a7 7 0 1114 0H3z'
        clipRule='evenodd'
      ></path>
    </svg>
  );
}
export function DownArrowIcon() {
  return (
    <svg
      sidebar-toggle-item=''
      className='w-6 h-6'
      fill='currentColor'
      viewBox='0 0 20 20'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        fillRule='evenodd'
        d='M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z'
        clipRule='evenodd'
      ></path>
    </svg>
  );
}
export function LoaderIcon() {
  return (
    <svg
      role='status'
      className='inline w-4 h-4 mr-2 text-gray-200 animate-spin dark:text-gray-600 fill-blue-600'
      viewBox='0 0 100 101'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z'
        fill='currentColor'
      />
      <path
        d='M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z'
        fill='currentFill'
      />
    </svg>
  );
}
export function NoPageIcon() {
  return (
    <svg
      id='Layer_1'
      data-name='Layer 1'
      xmlns='http://www.w3.org/2000/svg'
      viewBox='0 0 512 512'
      className='flex-shrink-1'
    >
      <title>crane-glyph</title>
      <path
        d='M103.33,41.35,83.15,54.61a3,3,0,0,0-1,3.91L95.08,83.1a3,3,0,0,0,5.62-.84l7.23-37.84A3,3,0,0,0,103.33,41.35Z'
        fill='none'
      />
      <path
        d='M142.59,91.63,127.65,65.7a3,3,0,0,0-5.54.85L112.93,108a3,3,0,0,0,4.56,3.18l24.12-15.53A3,3,0,0,0,142.59,91.63Z'
        fill='none'
      />
      <path
        d='M151.65,119.31l-22.31,14.51a3,3,0,0,0-1,3.95L141.9,163a3,3,0,0,0,5.59-.78l8.73-39.73A3,3,0,0,0,151.65,119.31Z'
        fill='none'
      />
      <rect
        x='374.82'
        y='219.38'
        width='73.87'
        height='63.31'
        rx='3.01'
        ry='3.01'
        fill='none'
      />
      <path
        d='M85,92.56A3,3,0,0,0,79.35,94V195.27a3,3,0,0,0,3,3H86.9a3,3,0,0,0,3-3V102.53a3,3,0,0,0-.35-1.41Z'
        fill='none'
      />
      <path
        d='M191.75,163.74,174.8,139a3,3,0,0,0-5.42,1.09l-8.54,41.05a3,3,0,0,0,4.57,3.14L190.9,168A3,3,0,0,0,191.75,163.74Z'
        fill='none'
      />
      <rect
        x='237.64'
        y='430.33'
        width='232.15'
        height='31.66'
        rx='3.01'
        ry='3.01'
        fill='none'
      />
      <path
        d='M197.6,192.62l-28.11,19.26a3,3,0,0,0-1,3.85l12.1,23.61a3,3,0,0,0,5.49-.32l16-42.87A3,3,0,0,0,197.6,192.62Z'
        fill='none'
      />
      <path
        d='M292.7,301.42l-20.39-27.81a3,3,0,0,0-5.15.51l-25.07,54a3,3,0,0,0,4.23,3.87l45.47-26.23A3,3,0,0,0,292.7,301.42Z'
        fill='none'
      />
      <path
        d='M242.41,254.8l-34.85,24.88a3,3,0,0,0-.87,3.93l14,24.77a3,3,0,0,0,5.39-.32l20.81-49.65A3,3,0,0,0,242.41,254.8Z'
        fill='none'
      />
      <path
        d='M241.33,232,223.78,207.9a3,3,0,0,0-5.23.68l-16.74,43a3,3,0,0,0,4.44,3.61l35.21-22.92Z'
        fill='none'
      />
      <path
        d='M472.06,388.12H427.58v-7.45a3,3,0,0,1,3-3h57.3a3,3,0,0,0,3-3V180.18a3,3,0,0,0-3-3H335.62a3,3,0,0,0-3,3v98h0l11.94,32.12a3,3,0,0,1-2.82,4.06H325a3,3,0,0,1-2.44-1.25L104.31,9.06a3,3,0,0,0-4-.82L56.57,34.62a3,3,0,0,0-1.06,4.07l12.89,22.6a3,3,0,0,1,.4,1.49V195.27a3,3,0,0,1-3,3h-9.1a3,3,0,0,0-3,3.43l9.62,67.85a3,3,0,0,0,3,2.59h2.5v20.44a3,3,0,0,1-1.63,2.67c-9,4.61-18.42,13.74-18.42,29.44,0,9.77,3.33,17.23,8.43,22.6a3,3,0,0,1-.21,4.35L8.39,393.48a3,3,0,0,0,2,5.29h7a3,3,0,0,0,2-.73l48.5-41.79a3,3,0,0,1,2.91-.57,39.31,39.31,0,0,0,12.78,2.21,29.51,29.51,0,0,0,12.43-2.82,3,3,0,0,1,3.16.38l52.62,42.65a3,3,0,0,0,1.89.67l6.12-.06a3.38,3.38,0,0,0,2.1-6l-53.65-43.48a3,3,0,0,1-.61-4A32.47,32.47,0,0,0,113,326.45a10.55,10.55,0,1,0-21.1,0,15.85,15.85,0,0,1-.41,3.77,3,3,0,0,1-4.81,1.6l0,0a5.28,5.28,0,0,0-6.76.11l-2.31,2a3,3,0,0,1-3.81.11c-2.31-1.81-3.89-4.71-3.89-9.32,0-9.54,9.47-11.85,11.25-12.19a10.57,10.57,0,0,0,8.8-10.42V275.15a3,3,0,0,1,3-3h6.24a3,3,0,0,0,2.95-2.42l13.56-67.85a3,3,0,0,0-2.95-3.6h-9.25a3,3,0,0,1-3-3V134a3,3,0,0,1,5.68-1.39L226.75,364.74a3,3,0,0,1,.34,1.39v8.53a3,3,0,0,0,3,3h36.19a3,3,0,0,1,3,3v7.45H242.92c-31.33,0-47.49,14.84-47.49,36.93v44.52c0,23.08,15.5,34.62,47.49,34.62H475.07c23.31,0,36.93-15.5,36.93-44.85V428.06A39.94,39.94,0,0,0,472.06,388.12ZM374.82,222.39a3,3,0,0,1,3-3h67.85a3,3,0,0,1,3,3v57.3a3,3,0,0,1-3,3H377.83a3,3,0,0,1-3-3ZM89.91,195.27a3,3,0,0,1-3,3H82.36a3,3,0,0,1-3-3V94A3,3,0,0,1,85,92.56l4.54,8.56a3,3,0,0,1,.35,1.41Zm18-150.84L100.7,82.27a3,3,0,0,1-5.62.84L82.14,58.53a3,3,0,0,1,1-3.91l20.17-13.26A3,3,0,0,1,107.93,44.43Zm5,63.59,9.18-41.46a3,3,0,0,1,5.54-.85l14.94,25.93a3,3,0,0,1-1,4L117.49,111.2A3,3,0,0,1,112.93,108Zm43.3,14.46-8.73,39.73a3,3,0,0,1-5.59.78l-13.57-25.22a3,3,0,0,1,1-3.95l22.31-14.51A3,3,0,0,1,156.22,122.48Zm4.61,58.67,8.54-41.05A3,3,0,0,1,174.8,139l17,24.73a3,3,0,0,1-.86,4.23L165.4,184.3A3,3,0,0,1,160.84,181.15Zm19.78,58.19-12.1-23.61a3,3,0,0,1,1-3.85l28.11-19.26a3,3,0,0,1,4.52,3.53l-16,42.87A3,3,0,0,1,180.62,239.34Zm21.18,12.18,16.74-43a3,3,0,0,1,5.23-.68L241.33,232l.13.18-35.21,22.92A3,3,0,0,1,201.8,251.52Zm24.32,56.54a3,3,0,0,1-5.39.32l-14-24.77a3,3,0,0,1,.87-3.93l34.85-24.88a3,3,0,0,1,4.52,3.61Zm20.19,24a3,3,0,0,1-4.23-3.87l25.07-54a3,3,0,0,1,5.15-.51l20.39,27.81a3,3,0,0,1-.92,4.38ZM469.79,459a3,3,0,0,1-3,3H240.65a3,3,0,0,1-3-3V433.34a3,3,0,0,1,3-3H466.78a3,3,0,0,1,3,3Z'
        fill='#ffffff'
      />
      <path
        d='M165.83,409.32H3a3,3,0,0,0-3,3v15.09a3,3,0,0,0,3,3H18.1a3,3,0,0,1,3,3v25.64a3,3,0,0,1-3,3H3a3,3,0,0,0-3,3v15.09a3,3,0,0,0,3,3H165.83a3,3,0,0,0,3-3V465.09a3,3,0,0,0-3-3H150.74a3,3,0,0,1-3-3V433.43a3,3,0,0,1,3-3h15.09a3,3,0,0,0,3-3V412.33A3,3,0,0,0,165.83,409.32Z'
        fill='#ffffff'
      />
    </svg>
  );
}
export function SavingsIcon() {
  return (
    <svg
      version='1.0'
      xmlns='http://www.w3.org/2000/svg'
      width='40'
      height='40'
      viewBox='0 0 48.000000 48.000000'
      preserveAspectRatio='xMidYMid meet'
    >
      <g
        transform='translate(0.000000,48.000000) scale(0.100000,-0.100000)'
        fill='#3084CB'
        stroke='none'
      >
        <path
          d='M160 435 c-17 -18 -21 -31 -17 -53 5 -25 2 -31 -28 -45 -19 -9 -42
-29 -52 -44 -10 -15 -24 -33 -32 -39 -11 -9 -12 -15 -4 -25 13 -17 39 -100 48
-151 6 -36 8 -38 45 -38 28 0 40 4 40 14 0 12 12 13 58 9 31 -3 60 -10 63 -15
3 -5 21 -8 40 -6 28 2 35 8 37 28 5 31 40 70 63 70 12 0 21 11 27 32 8 30 5
36 -25 66 -32 31 -33 37 -27 78 l6 45 -66 -7 -66 -7 6 32 c8 40 -26 81 -66 81
-15 0 -36 -10 -50 -25z m75 -45 c0 -18 -6 -26 -23 -28 -13 -2 -25 3 -28 12
-10 26 4 48 28 44 17 -2 23 -10 23 -28z m89 -80 c23 0 27 -4 23 -20 -3 -10 1
-24 8 -30 7 -6 16 -22 19 -35 4 -14 13 -25 21 -25 18 0 20 -20 3 -20 -20 -1
-88 -68 -88 -88 0 -13 -2 -14 -9 -4 -5 8 -32 15 -67 17 -33 1 -69 6 -81 10
-19 6 -23 4 -23 -14 0 -39 -16 -21 -29 31 -24 102 -24 112 0 141 31 40 55 48
129 42 36 -3 78 -5 94 -5z'
        />
        <path
          d='M304 229 c-10 -17 13 -36 27 -22 12 12 4 33 -11 33 -5 0 -12 -5 -16
-11z'
        />
      </g>
    </svg>
  );
}

export function BackButton() {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      class='icon icon-tabler icon-tabler-arrow-left'
      width='32'
      height='32'
      viewBox='0 0 24 24'
      stroke-width='2'
      stroke='currentColor'
      fill='none'
      stroke-linecap='round'
      stroke-linejoin='round'
    >
      <path stroke='none' d='M0 0h24v24H0z' fill='none'></path>
      <line x1='5' y1='12' x2='19' y2='12'></line>
      <line x1='5' y1='12' x2='11' y2='18'></line>
      <line x1='5' y1='12' x2='11' y2='6'></line>
    </svg>
  );
}

export function Safe() {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='35'
      height='35'
      className='si-glyph si-glyph-safe-box'
      viewBox='0 -0.5 17 17'
    >
      <g fill='none' fillRule='evenodd'>
        <path
          d='M12.001.979H2.018C1.411.979.98 1.333.98 2.017v11.021c0 .684.5 1.004 1.06 1.004h9.94c.562 0 1.06-.375 1.06-1.047V2.015c0-.568-.54-1.036-1.039-1.036zM12 13H2V2h10v11z'
          transform='translate(1)'
        ></path>
        <path
          fill='#58a8ff'
          d='M11.901.016H2.16C1.002.016 0 .907 0 2.005V13c0 1.099.871 1.989 2.028 1.989h.012V16H4v-1.011h6V16h2v-1.012c1.152-.005 1.998-.894 1.998-1.988V2.005c0-1.099-.938-1.989-2.097-1.989zm1.138 12.979c0 .672-.497 1.047-1.06 1.047h-9.94c-.56 0-1.06-.32-1.06-1.004V2.017c0-.685.431-1.038 1.038-1.038H12c.499 0 1.038.467 1.038 1.035l.001 10.981z'
          className='si-glyph-fill'
          transform='translate(1)'
        ></path>
        <path
          fill='#58a8ff'
          d='M2 13h10V2H2v11zm5-7a2 2 0 012 2h1v1H8.723c-.347.595-.984 1-1.723 1a2 2 0 010-4z'
          className='si-glyph-fill'
          transform='translate(1)'
        ></path>
      </g>
    </svg>
  );
}

export function Cross() {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='40'
      height='40'
      fill='currentColor'
      class='bi bi-x'
      viewBox='0 0 16 16'
    >
      {' '}
      <path d='M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z' />{' '}
    </svg>
  );
}

export function Announce() {
  return (
    <svg
      fill='#737373'
      height='30'
      width='18'
      version='1.1'
      id='Layer_1'
      xmlns='http://www.w3.org/2000/svg'
      className='text-gray-500'
      viewBox='0 0 239.563 239.563'
    >
      <g>
        <g>
          <g>
            <path
              d='M146.962,36.978h-1.953L85.568,69.611H42.605C19.113,69.611,0,88.723,0,112.216c0,21.012,15.301,38.474,35.334,41.943
				L21.56,202.585h47.523l13.584-47.756h2.901l59.443,32.628h1.953c12.585,0,22.826-10.239,22.826-22.826V59.803
				C169.787,47.219,159.546,36.978,146.962,36.978z M57.592,187.366H41.71l8.352-29.364h15.882L57.592,187.366z M109.459,150.581
				l-19.988-10.972H42.605c-15.103,0-27.388-12.29-27.388-27.393c0-15.103,12.285-27.388,27.388-27.388h46.866l19.988-10.974
				V150.581z M154.57,164.631c0,3.637-2.567,6.683-5.978,7.431l-23.916-13.127V65.502l23.916-13.13
				c3.414,0.748,5.978,3.797,5.978,7.434V164.631z'
            />
            <path
              d='M198.989,79.377L188.106,90.26c5.623,7.789,8.976,17.32,8.976,27.637c0,10.32-3.353,19.851-8.976,27.637l10.883,10.883
				c8.326-10.629,13.31-24,13.31-38.52C212.299,103.377,207.315,90.007,198.989,79.377z'
            />
            <path
              d='M218.358,60.009l-10.794,10.794c10.482,12.856,16.782,29.252,16.782,47.094c0,17.845-6.3,34.238-16.782,47.094
				l10.794,10.794c13.216-15.648,21.205-35.849,21.205-57.888S231.574,75.657,218.358,60.009z'
            />
          </g>
        </g>
      </g>
    </svg>
  );
}

export function Copy() {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='22' height='22' id='copy'>
      <g
        fill='none'
        fill-rule='evenodd'
        stroke='#000'
        stroke-linecap='round'
        stroke-linejoin='round'
        stroke-width='2'
        transform='translate(1 1)'
      >
        <rect width='13' height='13' x='7' y='7' rx='2'></rect>
        <path d='M3 13H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1'></path>
      </g>
    </svg>
  );
}

export const Gift = (props) => (
  <svg
    width='1em'
    height='1em'
    viewBox='0 0 16 16'
    xmlns='http://www.w3.org/2000/svg'
    className='h-5 w-5 text-gray-500'
    {...props}
  >
    <path
      fill='currentColor'
      d='M10.1 5c2-.3 3.9-1.1 2.2-3.6c-.7-1-1.4-1.4-2-1.4c-1 0-1.7 1.1-2.3 2.2C7.4 1.1 6.7 0 5.7 0c-.6 0-1.3.4-2 1.4c-1.8 2.5.2 3.3 2.2 3.6H0v3h16V5zm.2-4c.1 0 .5.1 1.2 1c.5.7.6 1.1.5 1.3c-.2.3-1.3.7-3.3.8c0-.2-.1-.4-.2-.6C9.1 2.1 9.8 1 10.3 1M4 3.3c-.1-.2 0-.6.5-1.3c.7-.9 1.1-1 1.2-1c.5 0 1.2 1.1 1.8 2.5c-.1.2-.2.4-.2.6c-2-.1-3.1-.5-3.3-.8M7 7V5h2v2zm2 8H7V9H1v7h14V9H9z'
    ></path>
  </svg>
);
